import { Box } from '@mui/material';
import { AppConnectorBlock, FeatureToggle, PhSiteSettings } from '../../models/app-data-model';
import AppConnectorConnectToBlock from '../app-connector-connect-to-block/AppConnectorConnectToBlock'
import useFeatureToggle from "design-system/shared/hooks/use-feature-toggle/useFeatureToggle";
import './AppConnector.scss';

import React from 'react';

export type AppConnectorProps = {
  appConnectorData?: AppConnectorBlock;
  phSiteSettings: PhSiteSettings;
};

const AppConnector: React.FC<AppConnectorProps> = ({ appConnectorData, phSiteSettings }) => {
  const featureToggles = phSiteSettings?.feature_toggles;
  const isSlfsvc226On = useFeatureToggle('SLFSVC-226', featureToggles)
  const appconnectorLinkData = appConnectorData?.connect_to.map((data, index) => <AppConnectorConnectToBlock connectToData={data} key={index} phSiteSettings={phSiteSettings} />)
  return <Box className={`app-connector ${isSlfsvc226On ? 'isSlfsvc226On' : ''}`}>
    {appconnectorLinkData}
  </Box>;
};

export default AppConnector;
